export default __webpack_public_path__ + "static/media/Pilgrim's Headdress.a3f0b918.jpg";